export const TOKEN = 'token'
export const REFRESH_TOKEN = ''
export const TOKEN_URL = ''
export const validExist = () => {
    return !!sessionStorage.getItem(TOKEN)
}

export const getMenuByPath = (menus, path) => {
    for (let i = 0, menu; (menu = menus[i++]);) {
        if (menu.path && menu.path === path) {
            return menu
        } else if (menu.children && menu.children.length) {
            const curMenu = getMenuByPath(menu.children, path)
            if (curMenu !== undefined) {
                return curMenu
            }
        }
    }
}

export function getMenu(menus, func) {
    for (const data of menus) {
        if (func(data)) return data
        if (data.children) {
            const res = getMenu(data.children, func)
            if (res) return res
        }
    }
    return null
}

export const parseQueryParamsByUrl = (url, name) => {
    let params = [],
        h
    let hash = url.slice(url.indexOf('?') + 1).split('&')
    for (let i = 0; i < hash.length; i++) {
        h = hash[i].split('=')
        params[h[0]] = h[1]
    }
    return decodeURI(params[name])
}

export const timestampToTime = timestamp => {
    if (!timestamp) {
        return timestamp
    }
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
}

export const timestampToDate = timestamp => {
    if (!timestamp) {
        return timestamp
    }
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    return Y + M + D
}

export const monthStartDate = now => {

    let nowMonth = now.getMonth(); //当前月
    let nowYear = now.getFullYear(); //当前年
    //本月的开始时间
    let monthStartDate = new Date(nowYear, nowMonth, 1);
    return timestampToDate(monthStartDate);

}
export const monthEndDate = now => {

    let nowMonth = now.getMonth(); //当前月
    let nowYear = now.getFullYear(); //当前年
    //本月的结束时间
    let monthEndDate =  new Date(nowYear, nowMonth+1, 0);
    return timestampToDate(monthEndDate);
}

export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

export const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

export const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

export function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
}

export function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
}

export function delCookie(name) {
    setCookie(name, null, -1);
}

export function listToTree(list) {
    let info = list.reduce((map, node) => (map[node.id] = node, node.children = [], map), {})
    return list.filter(node => {
        info[node.parentId] && info[node.parentId].children.push(node)
        return !node.parentId
    })
}

export function formatMoney(val) {
    if (val) {
        if (Number(val).toString() !== "NaN") {
            return parseFloat((val / 10000).toFixed(6))
        } else {
            return val
        }
    }

    return 0
}

export function travelTree(tree, func) {
    tree.forEach(data => {
        func(data)
        data.children && treeForeach(data.children, func)
    })
}

export function toTree(data, parentId) {
    let tree = [];
    let temp;
    for (let i = 0; i < data.length; i++) {
        if (data[i].parentId === parentId) {
            let obj = data[i];
            temp = toTree(data, data[i].id);
            if (temp.length > 0) {
                obj.children = temp;
            }
            tree.push(obj);
        }
    }
    return tree;
}



// WEBPACK FOOTER //
// ./src/utils/index.js